import useAccessRight from "../../../hooks/useAccessRight";
import { useListState } from "../../../hooks";
import { CLS, SERVER } from "../../../constants/accessRights";
import TagsWrapper from "../../../HOC/TagsWrapper/TagsWrapper";
import Tag from "../Tag/Tag";
import { CallingLineCalendar, CallingLineIntervals, CallingLineListScripts, CallingLineLogs, CallingLineParams, ServerStatus } from "@/components";
import { selectClsHints } from "@/store/hintsSlice";
import { useAppSelector } from "@/store/hooks";

const CallingListTags = (): JSX.Element => {
	const { state, toggleState } = useListState({
		tagList: ["button_scripts", "button_intervals", "button_calendar", "button_logs", "button_servers", "button_params"],
	});
	const clsHints = useAppSelector(selectClsHints);

	const isAccess = useAccessRight(); // hook для проверки прав доступа

	return (
		<>
			<TagsWrapper>
				{<Tag setShowTag={toggleState("button_params")} tagName="button_settings" hint={clsHints.hint_clsCallListSettings} />}
				{isAccess([CLS.LISTS_MODIFY, CLS.LISTS_LIST]) && <Tag setShowTag={toggleState("button_scripts")} tagName="button_scripts" hint={clsHints.hint_clsScripts} />}
				{isAccess([CLS.TIMEINTERVALS_GET]) && <Tag setShowTag={toggleState("button_intervals")} tagName="button_intervals" hint={clsHints.hint_clsIntervals} />}
				{isAccess(CLS.CONFIGS_GET) && <Tag setShowTag={toggleState("button_calendar")} tagName="button_calendar" hint={clsHints.hint_clsCalendar} />}
				{isAccess(CLS.LOGS) && <Tag setShowTag={toggleState("button_logs")} tagName="button_logs" hint={clsHints.hint_clsLogs} />}
				{isAccess(SERVER.ADDRESSES) && <Tag setShowTag={toggleState("button_servers")} tagName="button_servers" serverStatus hint={clsHints.hint_clsServerTab} />}
			</TagsWrapper>

			<CallingLineCalendar showCalendar={state.button_calendar} setShowCalendar={toggleState("button_calendar")} />
			<CallingLineListScripts showScripts={state.button_scripts} setShowScripts={toggleState("button_scripts")} />
			<CallingLineIntervals hint={clsHints.hint_clsCreateInterval} showIntervals={state.button_intervals} setShowIntervals={toggleState("button_intervals")} />
			<CallingLineLogs showLogs={state.button_logs} setShowLogs={toggleState("button_logs")} />
			<ServerStatus showServers={state.button_servers} setShowServers={toggleState("button_servers")} serviceType="cls" />
			<CallingLineParams
				telegramChannelHint={clsHints.hint_clsTelegramChannelSettings}
				voiceChannelHint={clsHints.hint_clsVoiceChannelSettings}
				showLogs={state.button_params}
				setShowParams={toggleState("button_params")}
			/>
		</>
	);
};

export default CallingListTags;
